import React, { useContext, useState } from "react";
import { StatusContext } from "../../contexts/Status.context";

import "./topbar.css";
import { UserInfoContext } from "../../contexts/UserInfo.context";
import LanguageSelection from "../UI/LanguageSelection";
import useTranslation from "../../hooks/useTranslation";
import { FaHome, FaQuestionCircle, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Topbar: React.FC = () => {
  const {
    pageStatus,
    setPageStatus,
    setMechanics,
    setEngine,
    setProblemNumber,
  } = useContext(StatusContext);
  const { fullname, isLogged, setScore } = useContext(UserInfoContext);
  const { t } = useTranslation();
  const location = useLocation();

  const handlePageStatus = (page: string) => {
    setPageStatus(page);
    setMechanics(0);
    setEngine("menu");
    setProblemNumber(0);
    setScore(0);
  };

  return (
    <>
      <div className="topbar w-full flex items-center justify-between">
        <div
          className={`${
            location.pathname === "/" && "topbar-personalize"
          } mx-5 px-6 py-2 md:px-6 md:py-4`}
        >
          {location.pathname === "/" && (
            <p className="text-2xl font-bold mb-1 md:block hidden">
              Micro Expressions Training Videos
            </p>
          )}
          {location.pathname === "/" && (
            <p className="text-sm font-bold mb-1 md:hidden block">
              Micro Expressions Training Videos
            </p>
          )}
          {/* <p className="text-[10px] md:text-base">
            {isLogged && `with ${fullname}`}
          </p> */}
        </div>
        {location.pathname === "/" && (
          <div className="topbar-state hidden lg:block ml-auto">
            {t(pageStatus)}
          </div>
        )}
        <div className="md:mx-2">
          <LanguageSelection />
        </div>
        {location.pathname === "/" && (
          <div
            className="topbar-menu-btn ml-1"
            onClick={() => handlePageStatus("Menu")}
          >
            <div className="md:hidden">
              <FaHome />
            </div>
            <div className="hidden md:block">{t("menu")}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default Topbar;
